<template>
  <div class="sector">
    <SelectSector />
  </div>
</template>

<script>
import SelectSector from "@/components/select/SelectSector.vue";

export default {
  name: "Sector",
  components: {
    SelectSector
  }
};
</script>
